import React from 'react'
import {pageDomain} from './Service'

export const Footer = ({content, lang}) => {
    // Before logic
    // const footerContent = pageDomain === 'acy.com' ? content.acyau : content.acyltd;
    const texts = content.acyltd;
    return (
        <div
            className='footer-wrapper'
            // Temp fix the en risk warning under ar, plz delete if the text change back to ar
            style={{
                direction: "ltr",
                textAlign: "left"
            }}
        >
            {
                texts.map(text => (
                    <p key={text} dangerouslySetInnerHTML={{ __html: text}}/>
                ))
            }
            <p>{content.copyright} <a href={`/${lang}/support/terms-and-conditions`} target='__blank'>{content.tac}</a></p>
        </div>
    )
}